// Edge effects mixin
export const edgeEffects = {
  boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
};

export const subtleEdge = {
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)',
};

export const strongEdge = {
  boxShadow: '0 0 30px rgba(0, 0, 0, 0.15)',
};

export const edgeHighlight = {
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 0 20px rgba(0, 0, 0, 0.1)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
};
